// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NmqsX","questions":"styles_questions__2izmb","footer":"styles_footer__Q1NVT"};